import Intercom from 'react-intercom';
import React from 'react';
import { connect } from 'react-redux';
import { getEnvVar } from '@shoflo/polymer/utils/getEnvVar';
export const getEventRole = (eventRoles, eventId) => {
  return eventRoles && eventRoles.length > 0
    ? eventRoles.find(e => {
        return e.event === eventId;
      })
    : null;
};

export const getTeamRole = (teamRoles, teamId) => {
  return teamRoles && teamRoles.length > 0
    ? teamRoles.find(e => {
        return e.team === teamId;
      })
    : null;
};

function isAutomatedTestEmail(email) {
  return (
    (email.includes('automation-') && email.includes('shoflo.')) ||
    (email.includes('playwright') && email.includes('shoflo.'))
  );
}

/**
 * Redirect a user to the user dash or the team dash
 *
 * @param {*} param0
 */
export const IntercomContainer = ({ user, team, event }) => {
  if (!user || isAutomatedTestEmail(user.email)) return <span />;

  const appID = getEnvVar('REACT_APP_INTERCOM_APP_ID');

  const intercomUser = {
    user_id: user._id,
    email: user.email,
    name: `${user.firstName} ${user.lastName}`
  };

  if (event) {
    const eventRole = getEventRole(user.events, event._id);

    intercomUser.eventId = event._id;
    if (eventRole) intercomUser.eventRole = eventRole.role;
  }

  if (team) {
    const teamRole = getTeamRole(user.teams, team._id);

    intercomUser.teamId = team._id;
    intercomUser.industry = team.industry;

    if (teamRole)
      intercomUser.teamRole =
        teamRole.role === 'admin' ? 'team admin' : teamRole.role;
  }

  return <Intercom appID={appID} {...intercomUser} />;
};

export default connect(
  ({ user, team, event }) => ({ user, team, event }),
  {}
)(IntercomContainer);
